/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTiposDocumentos() {
        return axiosJwt.get(`${api}/tiposdocumentos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirDocumento(documento) {
        const formData = new FormData()
        formData.append('tipoDocumentoId', documento.tipoDocumentoId)
        formData.append('idContrato', documento.idContrato)
        formData.append('descricao', documento.descricao)
        formData.append('arquivo', documento.arquivo)
        formData.append('justificativaApostilamento', documento.justificativaApostilamento)
        formData.append('isApostilamento', documento.isApostilamento)
        formData.append('link', documento.link)

        return axiosJwt.post(`${api}/contratos/${documento.idContrato}/documentos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirDocumento(documento) {
        return axiosJwt.put(`${api}/contratos/${documento.idContrato}/documentos/${documento.documentoContratoId}`, documento)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterDocumento(documento) {
        return axiosJwt.get(`${api}/contratos/${documento.idContrato}/documentos/${documento.documentoContratoId}`, {
                responseType: 'blob'
            })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterDocumentos(contratoId) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/documentos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }
}
